<template>
  <div>
    <el-row>
      <el-form size="small">
        <el-col :span="6">
          <el-form-item>
            <el-input
              v-model="form.resourceName"
              maxlength="45"
              placeholder="请输入资源名称"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item>
            <el-select placeholder="请选择资源时长" clearable style="width:100%;margin-left:8px" v-model="form.duration">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
        <el-button size="small" type="primary" style="margin-left:15px" @click="handleSearch"
          >查询</el-button
        >
        </el-col>
      </el-form>
    </el-row>
    <div v-if="!isLoading && table.total === 0" class="lastest-nothing">
      <span> 暂无数据</span>
    </div>
    <CardList class="img-list" :data="table.data" v-loading="isLoading" v-else>
      <div class="img-item" slot="row" slot-scope="{ row: item }">
        <div class="img-item-box">
          <img
            referrerpolicy="no-referrer"
            :key="item.resourceUrl"
            :src="item.resourceIcon"
          />
        </div>
        <div class="img-title">{{ item.resourceName }}</div>
        <div class="img-detail">
          <el-button @click="handleNewMaterialAdd(item)">选择</el-button>
          <el-button @click="handleDel(item)">删除</el-button>
        </div>
        <div class="img-info" style="color: #FF8B00">
          <span> 时长： {{ item.duration }} </span>
        </div>
      </div>
    </CardList>
     <el-pagination
          :current-page.sync="currentPage"
          :page-size="10"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
           :total="table.total"
        ></el-pagination>

    <!-- <pagination
      v-bind:currentpage="currentPage"
      v-bind:pagesize="pageSize"
      v-bind:totalcount="table.total"
      @handle-size-change="handleSizeChange"
      @handle-current-change="handleCurrentChange"
    ></pagination> -->
  </div>
</template>
<script>
import { CardList } from '@ccprivate/admin-toolkit'
import { formatDuration } from '@/utils/smartCreation'
export default {
  components: {
    CardList
    // MaterialDetail
  },
  props: {
    editSelectedMaterial: {
      type: Array,
      default: function () {}
    },
    selectedPart: {
      type: String,
      default: 'lastestGeneration'
    },
    onlineClip: {
      type: Boolean,
      default: false
    },
    editId: {
      type: Number,
      default: null
    },
    spaceInfo: {
      type: Object,
      default: () => {}
    }
  },
  inject: ['handleMaterialAdd', 'getSelectedMaterial'],
  data() {
    return {
      timePicker: 0,
      videoData: [],
      videoDataAmount: 0,
      videoDataTotal: 0,
      mouseHover: 'hidden',
      mouseTarget: null,
      currentPage: 1,
      pageSize: 10,
      filter: {
        categoryId: '-1',
        tags: '',
        movieName: '',
        businessType: '-1',
        area: '-1',
        duration: 300,
        way: 0,
        wayContent: '',
        statement: ''
      },
      minDuration: 0,
      maxDuration: 600,
      areaList: [],
      categoryTypeList: [],
      businessTypeList: [],
      loadingImage: require('@/assets/onlineClip/material1004.png'),
      selectedTarget: {},
      isLoading: false,
      isShowMaterialDetail: false,
      isSelected: false,
      table: {
        data: [],
        total: 0
      },
      form: {
        resourceName: undefined,
        duration: undefined
      },

      options: [
        {
          label: '15s',
          value: 15
        },
        {
          label: '30s',
          value: 30
        }
      ],
      isFilter: false
    }
  },
  methods: {
    handleMaterialOver(material, index) {
      this.mouseTarget = index
      this.handleMaterialState(material)
    },
    handleMaterialState(material) {
      const isEdit = this.editId !== null ? 1 : 0
      const target = this.getSelectedMaterial(
        material,
        isEdit,
        this.editSelectedMaterial
      )
      if (target) {
        this.isSelected = true
      } else {
        this.isSelected = false
      }
    },
    handleNewMaterialAdd(item) {
      this.handleMaterialState(item)
      this.$emit('select-material', item)
      this.$emit('close-dialog')
    },
    handleMaterialShow(target) {
      if (/base64/.test(target.cover)) {
        this.isShowMaterialDetail = true
        this.selectedTarget = target
        this.selectedTarget.isSelected = this.isSelected
      } else {
        this.$message('素材尚在加载中，请稍后预览')
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      if (this.isFilter) {
        this.fetchData(this.form)
      } else {
        this.fetchData()
      }
    },
    handleCurrentChange(val) {
      this.currentPage = val
      if (this.isFilter) {
        this.fetchData(this.form)
      } else {
        this.fetchData()
      }
    },
    fetchData(filter) {
      this.isLoading = true
      const params = {
        ...filter,
        ...{ resourceType: 1, spaceId: this.spaceInfo.spaceId },
        ...{
          pageSize: this.pageSize,
          pageNo: this.currentPage
        }
      }
      this.$service
        .getHistoryResource(params)
        .then(res => {
          this.isLoading = false
          this.table.data = (res.rows || []).map(item => {
            return {
              agentAccountId: item.agentAccountId,
              createTime: item.createTime,
              duration: item.duration,
              format: item.format,
              height: item.height,
              md5: item.md5,
              relativePath: item.relativePath,
              resourceIcon: item.resourceIcon,
              resourceId: item.resourceId,
              resourceName: item.resourceName,
              resourceType: item.resourceType,
              resourceUrl: item.resourceUrl,
              size: item.size,
              spaceId: item.spaceId,
              width: item.width,
              startFrame: 0,
              endFrame: item.duration
            }
          })
          this.table.total = res.total || 0
        })
        .catch(() => {
          this.isLoading = false
        })
    },
    handleDel(item) {
      this.$emit('del-video', item)
    },
    handleSearch() {
      this.isFilter = true
      this.fetchData(this.form)
    }
  },
  created() {
    this.isFilter = false
    this.fetchData()
  }
}
</script>
<style lang="stylus" scoped>
.img-list-none
  width 100%
  display flex
  flex-direction row
  justify-content center
  align-items center
  color #909399
.img-list
  width 100%
  display flex
  flex-direction row
  height 392px
.img-list
  >>>.el-row
    width 100%
    margin 0 !important
>>>.card-item-wrapper
  width 19.1%
  margin-right 9px
  margin-bottom 9px
  padding 0px !important
  // margin-right 9px
  height 175px
  background rgba(255,255,255,1)
  border-radius 2px
  border 1px solid rgba(233,233,233,1)
.img-list>>>.card-item-wrapper:nth-child(5n+5)
  margin-right 0
.img-item
  .img-item-box
    height 116px
    img
      width 100%
      max-height 100%
  .img-detail
    position absolute
    top 0
    text-align center
    background rgba(8, 8, 8, 0.5)
    width 100%
    display none
    height inherit
    line-height 175px
    .detail-button
      margin-top -50px
      top 50%
      position relative
    span
      display block
  &:hover
    .img-detail
      display block
  .img-info
    font-size 12px
    padding 0px 8px 8px
    position absolute
    top 98px
  .img-title
    height 40px
    line-height 20px
    padding 8px 8px 0px 8px
    position relative
    text-overflow ellipsis
    overflow hidden
    display: -moz-box
    -moz-line-clamp 2 !important
    -moz-box-orient vertical
    /* autoprefixer: off */
    display: -webkit-box
    -webkit-line-clamp: 2
    -webkit-box-orient: vertical
  .img-status
    float right
  .img-preview
    position absolute
    top 0
    right 0
    cursor pointer
    height 20px
    color #444
    background #fff
    padding 0px 5px
.lastest-nothing
  margin 10px 0px 50px
  height 40px
  text-align center
  color #999
</style>
